import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./Usuario.module.css";
import load from "../../../../../Images/loading.gif";

function Usuario() {
    const { id } = useParams(); // ← pega o ID da URL
    const [user, setUser] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [cargo, setCargo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await fetch(`https://eclipsebots.com/api/users/${id}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include"
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch user");
                }

                const data = await response.json();
                setUser(data[0]);
            } catch (error) {
                console.error("Erro ao buscar usuário:", error);
                setUser(null);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [id]);

    const atualizarCargo = async (novoCargo) => {
        setCargo(novoCargo);

        try {
            const res = await fetch(`https://eclipsebots.com/api/users/updaterole/${user.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({ cargo: novoCargo }),
            });

            if (!res.ok) throw new Error("Falha ao atualizar cargo");

            setIsEditing(false);
            const updatedUser = { ...user, role: novoCargo };
            setUser(updatedUser);
        } catch (err) {
            console.error("Erro ao atualizar cargo:", err);
            alert("Erro ao atualizar o cargo.");
        }
    };


    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    if (!user) {
        return <div className={styles.noData}>Usuário não encontrado.</div>;
    }

    const createdDate = new Date(user.created);
    let created = createdDate.toLocaleString("pt-PT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).replace(",", " |");

    return (
        <div className={styles.users}>
            <div className={`${styles.user} ${styles.first} ${styles.last}`}>
                <div className={styles.header}>
                    <div className={styles.image}>
                        <img
                            src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.${user.avatar.startsWith("a_") ? "gif" : "png"}`}
                            alt="Imagem de Perfil"
                            nError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://i.imgur.com/bWhx7OT.png";
                            }}
                        />
                    </div>
                    <div className={`${styles.name} ${styles.imagem}`}>
                        <div>{user.username}</div>
                        <div><span>{user.id}</span></div>
                    </div>
                </div>
                <div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Email:</span> {user.email}
                    </div>
                    <div className={styles.topic}>
                        {isEditing ? (
                            <>
                                <select value={cargo} onChange={(e) => atualizarCargo(e.target.value)}>
                                    <option value="Membro">Membro</option>
                                    <option value="Booster">Booster</option>
                                    <option value="Beta">Beta</option>
                                    <option value="Cliente">Cliente</option>
                                    <option value="Parceiro">Parceiro</option>
                                    <option value="Suporte">Suporte</option>
                                    <option value="Developer">Developer</option>
                                    <option value="Gerente">Gerente</option>
                                    <option value="Administrador">Administrador</option>
                                </select>
                            </>
                        ) : (
                            <>
                                <span className={styles.title}>Cargo:</span> {user.role}
                                <button onClick={() => setIsEditing(true)}>✏️</button>
                            </>
                        )}

                    </div>
                    <div className={`${styles.topic} ${styles.top}`}>
                        <span className={styles.title}>Pagamentos realizados:</span> 0
                    </div>
                    <div className={`${styles.topic} ${styles.bottom}`}>
                        <span className={styles.title}>Valor em Pagamentos:</span> 0R$
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Conta criada em</span> {created}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Usuario;